import { T } from '@tolgee/react';
import styled from 'styled-components';

import { LLMMessageDTO } from '../../../../services/backendService/backendService';
import GameImageRenderer, {
  TextFileRenderer,
} from '../../../_molecules/GameImageRenderer/GameImageRenderer';
import { AttachmentPreview, BadgeText, TextFileBadge } from '../MaterialAttachments';

export function ChatAttachments({
  attachments,
}: {
  attachments: Required<LLMMessageDTO>['attachments'];
}) {
  return (
    <ChatAttachmentsGrid>
      {attachments.map(file => (
        <ChatAttachmentContainer key={file.fileId}>
          {file.mimeType.startsWith('image/') && (
            <AttachmentPreview>
              <GameImageRenderer
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
                fileId={file.fileId}
                fileMimetype={file.mimeType}
                fileAltText={''}
                isDiscoverTemplate={false}
                isAuthenticated
                isOwner // it should be impossible to not be owner and authenticated
              />
            </AttachmentPreview>
          )}
          {file.mimeType === 'text/plain' && (
            <AttachmentPreview>
              <TextFileRenderer fileId={file.fileId} />
              <TextFileBadge>
                <BadgeText>
                  <T keyName="Pasted" defaultValue="Pasted" />
                </BadgeText>
              </TextFileBadge>
            </AttachmentPreview>
          )}
        </ChatAttachmentContainer>
      ))}
    </ChatAttachmentsGrid>
  );
}

// Chat History Attachment Components
const ChatAttachmentsGrid = styled.div`
  display: grid;
  width: 100%;
  gap: 10px;
  height: 90px;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  grid-template-rows: 90px;
  position: relative;
  direction: rtl;
`;

const ChatAttachmentContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
